<template>
	<div style="padding-bottom: 80px;">
		<!-- 基本信息 -->
		<div class="inputList">
			<labelText spanTitle="推荐单位" :spanWidth="spanWidth" componentWidth="1000px"
				:pContent="formData.recommend_unit_name">
			</labelText>
			<labelText spanTitle="申报企业名称" :spanWidth="spanWidth" componentWidth="1000px"
				:pContent="formData.company_name">
			</labelText>
			<!-- area -->
			<labelText spanTitle="申报企业通讯地址" :spanWidth="spanWidth" componentWidth="1000px"
				:pContent="formData.province+formData.city+formData.address">
			</labelText>
			<labelText spanTitle="申报企业联系人" :spanWidth="spanWidth" componentWidth="520px"
				:pContent="formData.enp_contact_name">
			</labelText>
			<labelText spanTitle="申报企业联系电话" :spanWidth="spanWidth" componentWidth="520px"
				:pContent="formData.enp_contact_phone">
			</labelText>
		</div>
		<p class="view_head">
			建造师项目经理信息
		</p>
		<div class="inputList">
			<labelText spanTitle="姓名" :spanWidth="spanWidth" componentWidth="520px" :pContent="formData.real_name">
			</labelText>
			<labelText spanTitle="性别" :spanWidth="spanWidth" componentWidth="520px" :pContent="formData.sex">
			</labelText>
			<labelText spanTitle="出生年月" :spanWidth="spanWidth" componentWidth="520px" :pContent="formData.birth_date">
			</labelText>
			<labelText spanTitle="政治面貌" :spanWidth="spanWidth" componentWidth="520px" :pContent="formData.politic">
			</labelText>
			<labelText spanTitle="身份证号" :spanWidth="spanWidth" componentWidth="520px" :pContent="formData.id_card">
			</labelText>
			<labelText spanTitle="专业技术职称" :spanWidth="spanWidth" componentWidth="520px" :pContent="formData.title">
			</labelText>
			<labelText spanTitle="最高学历" :spanWidth="spanWidth" componentWidth="520px" :pContent="formData.education">
			</labelText>
			<labelText spanTitle="所学专业" :spanWidth="spanWidth" componentWidth="520px" :pContent="formData.major">
			</labelText>
			<labelText spanTitle="职务" :spanWidth="spanWidth" componentWidth="520px" :pContent="formData.post">
			</labelText>
			<labelText spanTitle="工作年限" :spanWidth="spanWidth" componentWidth="520px"
				:pContent="formData.join_work_time">
			</labelText>
			<labelText spanTitle="建造师等级" :spanWidth="spanWidth" componentWidth="520px"
					   :pContent="formData.level">
			</labelText>
			<labelText spanTitle="建造师专业" :spanWidth="spanWidth" componentWidth="520px"
				:pContent="formData.construct_major">
			</labelText>

			<labelText spanTitle="注册证书编号" :spanWidth="spanWidth" componentWidth="520px" :pContent="formData.req_num">
			</labelText>
			<!-- <labelText spanTitle="继续教育证书编号" :spanWidth="spanWidth" componentWidth="520px"
				:pContent="formData.certificate_num">
			</labelText> -->
		</div>
		<div style="display: flex">
			<labelText spanTitle="个人照片" :spanWidth="spanWidth" componentWidth="220px" pContent="">
			</labelText>
			<el-image style="width: 100px; height: 100px" :src="formData.headImg"
				:preview-src-list="[formData.headImg]">
			</el-image>
		</div>
	</div>
</template>
<script>
	import labelText from '../../../components/table/labelText.vue'
	export default {
		data() {
			return {
				formData: this.datas,
				spanWidth: '200px',
			}
		},
		components: {
			labelText
		},
		props: {
			datas: {
				type: Object,
				default: () => {}
			}
		}
	}
</script>

<style scoped>
	.inputList {
		display: flex;
		flex-wrap: wrap;
		margin-top: 20px;
	}

	.view_head {
		font-size: 18px;
		font-weight: 600;
		margin-top: 20px;
	}
</style>
